"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 16 16" id=icon-chevron-down-16><path d="M8.707 12.707a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 1.414-1.414L8 10.586l5.293-5.293a1 1 0 1 1 1.414 1.414l-6 6Z"></path></symbol>';
}
